import { CommandBase } from "../CommandBase.js";
import { Utils } from "../../../system/utils/utils.js"; // Needed for Utils.sleep

export class ExitCommand extends CommandBase {
    constructor(kernel) {
        super(kernel);
        // Get the core state dependencies
        this.stateManager = kernel.get('state');
        this.eventBus = kernel.get('eventBus');
    }
    
    async execute(args) {
        this.write("Returning to GUI /home...", 'text-green');
        
        // Use Utils.sleep if motion isn't reduced (imported via relative path)
        if (!this.stateManager.get('ui.reducedMotion')) await Utils.sleep(300); 

        // 1. Set the view state back to 'gui'
        this.stateManager.set('ui.view', 'gui');

        // 2. Tell the GUI to navigate to the 'home' page
        this.eventBus.emit('page:navigate', { section: 'home', command: 'cat welcome.txt' });
    }
}